import { Nav, NavItem, NavLink, Button, Row, Col } from "reactstrap";
import Select from "react-select";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";

function APLTabs({
  toggleCreatePeriod,
  periodsToSelect,
  period,
  activeTab,
  handleSelectPeriod,
  selectedPeriod,
  handleSetAplTab,
}) {
  return (
    <>
      <DivNoScroll>
        <Nav tabs className="bg-primary">
          {period && (
            <>
              <NavItem style={{ margin: "auto 0" }}>
                <NavLink
                  className={
                    activeTab === 4 ? "active text-primary" : "text-white"
                  }
                  style={{ color: "white" }}
                  onClick={() => handleSetAplTab(4)}
                >
                  <FormattedMessage id="AdministerPeriod" />
                </NavLink>
              </NavItem>
              <NavItem style={{ margin: "auto 0" }}>
                <NavLink
                  className={
                    activeTab === 1 ? "active text-primary" : "text-white"
                  }
                  style={{ color: "white" }}
                  onClick={() => handleSetAplTab(1)}
                >
                  <FormattedMessage id="Presence" />
                </NavLink>
              </NavItem>
              <NavItem style={{ margin: "auto 0" }}>
                <NavLink
                  className={
                    activeTab === 2 ? "active text-primary" : "text-white"
                  }
                  style={{ color: "white" }}
                  onClick={() => handleSetAplTab(2)}
                >
                  <FormattedMessage id="Workcard" />
                </NavLink>
              </NavItem>
              <NavItem style={{ margin: "auto 0" }}>
                <NavLink
                  className={
                    activeTab === 3 ? "active text-primary" : "text-white"
                  }
                  style={{ color: "white" }}
                  onClick={() => handleSetAplTab(3)}
                >
                  <FormattedMessage id="WorkcardFeed" />
                </NavLink>
              </NavItem>
            </>
          )}
        </Nav>
      </DivNoScroll>
      <Row className="mt-2">
        <Col xs="3" className="ms-2 pe-1">
          <Select
            menuPortalTarget={document.body}
            styles={{
              padding: 0,
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPosition={"fixed"}
            options={periodsToSelect}
            value={
              selectedPeriod
                ? selectedPeriod
                : { value: null, label: "Välj period" }
            }
            onChange={(event) => {
              handleSelectPeriod(event);
            }}
            placeholder="Välj period"
          />
        </Col>
        <Col className="ps-1">
          <Button
            outline
            className="apl_header_createNewButton"
            onClick={toggleCreatePeriod}
          >
            <FormattedMessage id="NewAplPeriod" />
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default APLTabs;

const DivNoScroll = styled.div`
  overflow-x: scroll;
  white-space: nowrap;
  &::-webkit-scrollbar {
    display: none;
  }
`;
